import { PolicyStatus } from "src/constants";

export function convertPolicyStatusToPolicyStatusId(policyStt) {
    if(!policyStt) return undefined;
    if(policyStt.toUpperCase() == "ACTIVE") return PolicyStatus.Active;
    return PolicyStatus.Lapsed;
}

export function checkExistOverdueAndDue(duePremium) {
    if(!duePremium) return true;
    duePremium = duePremium.map(item => item.premiumType);
    let check = duePremium.includes("OVERDUE");
    check = check || duePremium.includes("DUE");
    return check;
}